import { render } from "./AddPlace.vue?vue&type=template&id=772b3e1c&ts=true"
import script from "./AddPlace.vue?vue&type=script&lang=ts"
export * from "./AddPlace.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__